import {
  ARConsoleFormatType,
  ARConsoleType,
  ARConsoleVersion,
} from '../../../../models/agrorendement-common-lists.model';
import { GCOrderItemConsole, GCParcel } from '../../../../models/agrorendement-genconsole.model';

export function isGenConsoleUnsupportedForAllConsoles(parcels: GCParcel[]) {
  for (const parcel of parcels) {
    if (isGenConsoleSupported(parcel.console)) {
      return false;
    }
  }
  return true;
}

export function isGenConsoleSupported(console: GCOrderItemConsole) {
  // Teejet, Challenger, Valtra, Massey Ferguson pas supporté
  // Format RDS + Version Amatron 4 OK mars 2022
  // Texte des warnings devra être changé si format ou consoles non supportés change
  return (
    isGenConsoleModelSupported(console.consoleType) &&
    isGenConsoleFormatSupported(console.consoleFormatType) &&
    isGenConsoleVersionSupported(console.consoleVersion)
  );
}

export function isGenConsoleModelSupported(consoleType: ARConsoleType) {
  return !(
    consoleType.code == 'TEEJET' ||
    consoleType.code == 'CHALLENGER' ||
    consoleType.code == 'MASSEY_FERGUSON' ||
    consoleType.code == 'VALTRA'
  );
}

export function isGenConsoleVersionSupported(consoleVersion: ARConsoleVersion) {
  //return consoleVersion.code != 'AMATRON_4';
  return consoleVersion.code;
}

export function isGenConsoleFormatSupported(format: ARConsoleFormatType) {
  //return format.code != 'RDS';
  return format.code;
}
